import { getOrSetDefault_Aside_isVisible } from './src/utils/page.js';

export * from './src/utils/error.js';
export * from './src/utils/modules.js';
export * from './src/utils/page.js';
export * from './src/utils/utils.js';

export const SDK = {
  init: () => {
    getOrSetDefault_Aside_isVisible();
  },
};
